import React from "react";
import "./FactPicker.css";
import { Operations } from "../../MathFactsGenerator/Constants.ts";
import { CHART_OPERATIONS, ChartOperation } from "./chartGame.ts";
import { signFor } from "./FactPicker.tsx";
import { useTranslation } from "../../Shared/i18n/useTranslation.ts";

/**
 * Which chart to fill: addition or multiplication, one at a time (ADR 0098 §2).
 * The look of the fact picker the soccer and plate games open with, but a
 * single choice limited to the two operations a chart can take, so it is a
 * sibling rather than a mode of `FactPicker`, whose value is a settings object.
 */
export function ChartPicker({ value, onChange }: {
    value: ChartOperation;
    onChange(operation: ChartOperation): void;
}) {
    const t = useTranslation();
    const names: Record<ChartOperation, string> = {
        [Operations.Addition]: t("flashCards.chartPickAddition"),
        [Operations.Multiplication]: t("flashCards.chartPickMultiplication"),
    };

    return (
        <div className="factPicker factPicker--two" role="group" aria-label={t("flashCards.chartWhichChart")}>
            {CHART_OPERATIONS.map((operation) => {
                const on = operation === value;
                return (
                    <button
                        key={operation}
                        type="button"
                        className={`factPickerButton${on ? " factPickerButton--on" : ""}`}
                        aria-pressed={on}
                        onClick={() => {
                            if (!on) {
                                onChange(operation);
                            }
                        }}
                    >
                        <span className="factPickerSign" aria-hidden="true">
                            {signFor(operation)}
                        </span>
                        <span className="factPickerName">{names[operation]}</span>
                    </button>
                );
            })}
        </div>
    );
}
